import { firebaseDb } from '@caresend/ui-components';
import { ref, remove } from 'firebase/database';

export const encodeFirebaseRef = (str: string) => encodeURIComponent(str).replace(/\./g, '%2E');

export const deleteFromDatabase = (path: string) => {
  remove(ref(firebaseDb, path));
};
